
import Table from 'react-bootstrap/Table';


function CalendarTable(props) {
  const { tableHeader, tableData } = props;
  return (
    <Table responsive bordered hover >
      <thead>
        <tr>
          {tableHeader?.map((el, index) => <th key={index}>{el}</th>)}

        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{tableData.description}</td>
          <td>{tableData.enabled ? "Enable" : "Not Enabled"}</td>
          <td>{tableData.startDate}</td>
          <td>{tableData.endDate}</td>
        </tr>
      </tbody>
    </Table>
  );
}

export default CalendarTable;